enum NodeTypeEnum {
	elementNode = 1,
	attributeNode = 2,
	textNode = 3,
	cdataSectionNode = 4,
	commentNode = 8,
	documentNode = 9,
	documentTypeNode = 10,
	documentFragmentNode = 11,
	processingInstructionNode = 7
}

export default NodeTypeEnum;
